import { useSnapshot } from 'valtio';

import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Text from '@cartwhl/ui/base/Text';

import { posingStore } from 'stores';
import { GizmoModeType, IKChainType } from 'stores/posingStore';

import { IK_SELECTORS } from '../constants';

// import Slider from '@cartwhl/ui/atoms/Slider';
// import NumberInput from './NumberInput';
// import TabButton from './TabButton';

export default function IKPanelContent() {
  // #region DATA
  const {
    activeIKChain,
    gizmoMode,
    gizmoGlobalRootActive: rootActive,
  } = useSnapshot(posingStore.state);

  const modeList =
    activeIKChain !== IKChainType.None
      ? IK_SELECTORS[activeIKChain].modeList
      : [];
  // #endregion

  return (
    <div className="flex min-w-fit flex-col">
      <header className="flex flex-col gap-2">
        {modeList.map((elm, i) =>
          CustomTabButton(gizmoMode, rootActive, elm, i),
        )}
        {/* SAVE FOR FUTURE <TabButton
          label="Position"
          click={() => chgTab(0)}
          active={idxTab === 0}
        /> */}
      </header>

      {/* SAVE FOR FUTURE <div className="border-gray-30 dark:border-gray-75 mt-2 flex w-[297px] gap-2 rounded-2xl border p-2">
          <NumberInput label="X" step={0.1} onChange={() => {}} />
          <NumberInput label="Y" step={0.1} onChange={() => {}} />
          <NumberInput label="Z" step={0.1} onChange={() => {}} />
        </div> */}
    </div>
  );
}

// Copy of TabButton
// 1. Add two text elements with flex row setup
// 2. All the logic to handle gizmo controls for IK Chain
function CustomTabButton(
  gizmoMode: GizmoModeType,
  rootActive: boolean,
  mode: { type: string; label: string; hotkey: string },
  key: number,
) {
  // #region DATA
  let active = false;
  let click = () => {};
  let isRoot = false;

  switch (mode.type) {
    case 'translate':
      active = gizmoMode === GizmoModeType.Translate;
      click = () => (posingStore.state.gizmoMode = GizmoModeType.Translate);
      break;
    case 'rotate':
      active = gizmoMode === GizmoModeType.Rotate;
      click = () => (posingStore.state.gizmoMode = GizmoModeType.Rotate);
      break;
    case 'twist':
      active =
        gizmoMode === GizmoModeType.zTwist ||
        gizmoMode === GizmoModeType.xTwist;
      click = () => (posingStore.state.gizmoMode = GizmoModeType.zTwist);
      break;
    case 'root':
      isRoot = true;
      active = rootActive;
      click = () => (posingStore.state.gizmoGlobalRootActive = !rootActive);
      break;
  }

  const clsActive = active
    ? 'bg-blue/10 text-gray-90 dark:text-gray-15 dark:bg-blue/60'
    : 'bg-gray-15 dark:bg-gray-75 text-gray-90 dark:text-gray-15 hover:bg-gray-30 dark:hover:bg-gray-60';
  // #endregion

  return !isRoot ? (
    <button
      key={key}
      onClick={click}
      className={`${clsActive} flex h-[30px] grow items-center justify-between rounded-lg px-4 py-1 transition-colors`}
    >
      <Text variant="studio/body/medium/xs">{mode.label}</Text>
      <Text variant="studio/body/medium/xs">( {mode.hotkey} )</Text>
    </button>
  ) : (
    <Checkbox
      key={key}
      id="root-checkbox"
      variant="checkbox"
      label={`${mode.label} ( ${mode.hotkey} )`}
      color="settings"
      checked={active}
      setChecked={click}
    />
  );
}
